/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiMeetingFeaturesAudioFromJSON(json) {
    return StreemApiMeetingFeaturesAudioFromJSONTyped(json, false);
}
export function StreemApiMeetingFeaturesAudioFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'echoReduction': !exists(json, 'echo_reduction') ? undefined : json['echo_reduction'],
    };
}
export function StreemApiMeetingFeaturesAudioToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'echo_reduction': value.echoReduction,
    };
}
//# sourceMappingURL=StreemApiMeetingFeaturesAudio.js.map